import React, {useEffect, useState} from "react";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {useGlobal} from "../../Store";
import {Button, Card, CardTitleBar, FormField, Select, TextInput} from "../UI";

const AddRatesComponent = ({area = "0", business = "0", department = "0"}) => {
    const [globalState, globalActions] = useGlobal()

    const [requestType, setRequestType] = useState('');
    const [meansType, setMeansType] = useState('');
    const [peakRate, setPeakRate] = useState('');
    const [normalRate, setNormalRate] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [requestTypeList, setRequestTypeList] = useState([]);
    const [meansTypeList, setMeansTypeList] = useState([]);

    useEffect(() => {
        loadMeansTypes()
        loadRequestTypes()
    }, []);


    function addRates(e) {
        e.preventDefault()

        let data = new FormData();
        data.append("business_id", business);
        data.append("department_id", department);
        data.append("area_id", area);
        data.append("request_type", requestType)
        data.append("means_type", meansType)
        data.append("normal_rate", normalRate)
        data.append("peak_rate", peakRate)

        setIsLoading(true)
        postData(Endpoints.RATE_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    setNormalRate('')
                    setPeakRate('')
                    globalActions.setObservableData({
                        ...globalState.observableData,
                        rates: !globalState.observableData.rates
                    })
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRequestTypes() {
        let data = new FormData();
        data.append("status", 1)
        data.append("area_id", area);

        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRequestTypeList(res.data || []);
                    if (res.data.length > 0) setRequestType(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadMeansTypes() {
        let data = new FormData();
        data.append("status", 1)
        data.append("area_id", area);

        setIsLoading(true)
        postData(Endpoints.MEANS_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setMeansTypeList(res.data || []);
                    if (res.data.length > 0) setMeansType(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <Card padded={false}>
            <CardTitleBar title="Add new rate"/>

            <div style={{padding: 24}}>
                <form onSubmit={addRates}>
                    <FormField label="Select request type">
                        <Select
                            value={requestType}
                            onChange={({target}) => setRequestType(target.value)}>
                            {requestTypeList.map((i, k) => <option
                                value={i.id}>{i.name}</option>
                            )}
                        </Select>
                    </FormField>

                    <FormField label="Select means type">
                        <Select
                            value={meansType}
                            onChange={({target}) => setMeansType(target.value)}>
                            {meansTypeList.map((i, k) => <option
                                value={i.id}>{i.name}</option>
                            )}
                        </Select>
                    </FormField>

                    <FormField label="Normal rate per KM in KES">
                        <TextInput
                            type="number"
                            required={true}
                            value={normalRate}
                            onChange={e => setNormalRate(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Peak rate per KM in KES">
                        <TextInput
                            type="number"
                            required={true}
                            value={peakRate}
                            onChange={e => setPeakRate(e.target.value)}
                        />
                    </FormField>

                    <Button type="submit" loading={isLoading}>Add</Button>
                </form>
            </div>
        </Card>
    )
};

export default AddRatesComponent;
